import React,{useContext} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import AuthContext  from './auth/Context';
/**
 * Component hiển thị một vòng quay loading ở chính giữa màn hình.
 * Lý tưởng để làm fallback cho Suspense khi tải toàn bộ trang.
 */
const LoadingSpinner = ({style}) => {
  const context = useContext(AuthContext);
  return (
    <div style={{top:0,bottom:0,left:0,right:0,zIndex:999999999,position:"fixed",display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",...style}}>
        <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",padding:10,borderRadius:5,backgroundColor:"transparent"}}>
            <CircularProgress style={{color: (style?.color || context.config?.primaryColor || "blue"),width:48,height:48}}/>
        </div>
    </div>
  );
};

export default LoadingSpinner;